import React, { useState, useEffect } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import { getItem, getItemToken } from "../../../Utils/localStorageUtils";
import { donwloadCSV, videodownloadPDF, videodownloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { CiShare1 } from "react-icons/ci";
import { FaEllipsisVertical } from "react-icons/fa6";
import { LiaUndoAltSolid } from "react-icons/lia";
import { BiRecycle } from "react-icons/bi";
import { RxReload } from "react-icons/rx";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AllVideo_Playlist() {
  const { fetchRequest, deleteImageFile } = useMyContext();
  const userRole = getItem('role');
  const BaseUrl = process.env.REACT_APP_Baseurl;
  const listApi = `${BaseUrl}/admin/video/playlist-index`;
  const multiDeleteApi = `${BaseUrl}/admin/video/playlist-multi-delete`;

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [draft, setDraft] = useState(0);
  const [deleteActionType, setDeleteActionType] = useState(2);
  const [total, setTotal] = useState('');
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [modelClose, setModelClose] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithoutRefresh] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    view_type: "list",
  });

  const fetchData = async () => {
    setLoading(true);
    await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        page,
        limit: formData?.title ? total?.totalItems : limit,
        search: formData?.title,
        soft_delete: draft,
      },
      data: {},
    })
      .then(response => {
        const result = response;
        setApiData(result?.data || []);
        setPage(result?.pagination?.currentPage || 1);
        setTotal(result?.pagination);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const fetchAllData = async (type, find) => {
    const data = await fetchRequest({
      method: 'GET',
      url: `${listApi}`,
      params: {
        search: find === "ALL" ? null : formData?.title,
        page: 1,
        limit: total?.totalItems,
        soft_delete: draft,
      },
      data: {},
    });

    let updatedList;
    if (find === "ALL") {
      updatedList = data?.data || [];
    } else {
      if (!itemToDelete || itemToDelete.length === 0) {
        alert("Please select at least one row to export.");
        return;
      }
      updatedList = data?.data?.filter(item => itemToDelete.includes(item?.id));
      if (!updatedList || updatedList.length === 0) {
        alert("Selected data not found.");
        return;
      }
    }

    const exportData = updatedList.map((item, index) => ({
      "S.NO": index + 1,
      "TITLE": item?.title,
      "SLUG": item?.slug,
      "VIDEOS": item?.video_count ?? (item?.selected_videos?.length || 0),
      "STATUS": Number(item?.status) === 1 ? "Active" : "Inactive",
      "CREATED": item?.upload_on,
    }));

    if (type === "CSV") {
      await donwloadCSV(exportData, "PLAYLIST-LIST");
    } else if (type === "PDF") {
      await videodownloadPDF(exportData, "PLAYLIST-LIST", [
        "S.NO", "TITLE", "SLUG", "VIDEOS", "STATUS", "CREATED"
      ]);
    } else if (type === "XLSX") {
      await videodownloadXLSX(exportData, "PLAYLIST-LIST", [
        "S.NO", "TITLE", "SLUG", "VIDEOS", "STATUS", "CREATED"
      ]);
    }
  };

  const handleDeleteImage = async () => {
    await deleteImageFile(itemToDelete, "AdminVideoPlaylist");
  };

  const handleConfirmDelete = async (actionType) => {
    setShowOverlay(true);
    // Only purge images on permanent delete so soft-deleted items stay restorable
    if (actionType === 1) {
      await handleDeleteImage();
    }
    await fetchRequest({
      method: 'DELETE',
      url: `${multiDeleteApi}`,
      params: {},
      data: { id: itemToDelete, action: actionType || deleteActionType },
    })
      .then(response => {
        const result = response;
        if (result?.status) {
          setWithoutRefresh(!withOutRefresh);
          toast.success(result?.message);
          setItemToDelete([]);
          setShowOverlay(false);
        }
        else {
          toast.error(result?.message);
          setShowOverlay(false);
        }
      })
      .catch(error => {
        setShowOverlay(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleSizePerPageChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const closeModal = () => {
    setModelClose(false);
    setItemToDelete([]);
    setDeleteActionType(draft === 1 ? 3 : 2);
  };

  const openModal = () => {
    setModelClose(true);
  };

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setDeleteActionType(draft === 1 ? 3 : 2);
  };

  const singlePermanentDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
    setDeleteActionType(1);
  };

  const handleDeletedata = () => {
    handleConfirmDelete(deleteActionType);
    setModelClose(false);
  };

  const reloadAction = () => {
    setDraft(0);
    setWithoutRefresh(prev => !prev);
  };

  const reCycleBin = () => {
    setDraft(prev => (prev === 1 ? 0 : 1));
    setItemToDelete([]);
  };

  const columns = [
    {
      dataField: "title",
      text: "Playlist Name",
      width: "35%",
      colStyle: "px-5",
      formatter: (cell, row) => {
        const baseUrl = process.env.REACT_APP_Baseurl_Frontend?.replace(/\/$/, '');
        const imageUrl = row?.banner_image || row?.image;
        const title = row?.title;
        const displayTitle = title?.length > 15 ? `${title?.slice(0, 15)}...` : title;
        return (
          <div className="d-flex justify-content-between align-items-center">
            {imageUrl ? (
              <img key={imageUrl} src={imageUrl} alt={title} className="profile theme-bg-color-secondary" />
            ) : (
              <div className="profile theme-bg-color-secondary text-dark d-flex align-items-center justify-content-center admin-input-title">
                {title?.slice(0, 1)?.toUpperCase()}
              </div>
            )}
            <div className="rightVideoTitle ms-2">
              <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank" to={`${baseUrl}/video-playlist/${row?.slug}`}>
                <span title={row?.slug}>{displayTitle}</span>
                <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: "1px", marginLeft: "6px" }} />
              </Link>
              <span className="dateText table-subheading theme-text-color">{row?.upload_on}</span>
            </div>
          </div>
        );
      },
      sort: true,
    },
    {
      dataField: "video_count",
      text: "Videos",
      width: "15%",
      rowStyle: "px-4",
      formatter: (cell, row) => <span className="theme-text-color">{row?.video_count ?? (row?.selected_videos?.length || 0)}</span>,
    },
    {
      dataField: "status",
      text: "Status",
      colStyle: "px-5",
      formatter: (cell) => <div className={`d-inline-flex justify-content-center px-3 py-1 text-center ${Number(cell) === 1 ? "PUBLISHED_active" : "UNPUBLISHED_active"}`}>{Number(cell) === 1 ? "Active" : "Inactive"}</div>,
    },
    ...(userRole == 1 ? [{
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="editdropdown">
          <span className="editdropdown-button">
            <FaEllipsisVertical />
          </span>
          <div className="editdropdown-menu theme-bg-color">
            {draft !== 1 && (
              <Link id="video-playlist-edit-link" to={`/edit-playlist/${row?.id}`} className="theme-text-color theme-bg-color">
                <span className="theme-text-color">
                  <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                  <MessageBox text="Edit" classname='ms-2 theme-text-color' />
                </span>
              </Link>
            )}
            <div id="video-playlist-delete-action" onClick={() => singleDelete(row?.id)} className="commonActionPadding theme-bg-color">
              {draft == 1 ? <LiaUndoAltSolid style={{ width: "20px", height: "20px" }} /> : <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />}
              <MessageBox text={`${draft == 1 ? "Undo" : "Delete"}`} classname='ms-2 theme-text-color' />
            </div>
            {draft == 1 && (
              <div id="video-playlist-permanent-delete" onClick={() => singlePermanentDelete(row?.id)} className="commonActionPadding theme-bg-color">
                <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                <MessageBox text="Delete Permanent" classname='ms-2 theme-text-color' />
              </div>
            )}
          </div>
        </div>
      ),
    }] : []),
  ];

  const options = {
    pageStartIndex: 1,
    paginationSize: 3,
    sizePerPage: 10,
    sizePerPageList: [
      { text: '5', value: 5 },
      { text: '10', value: 10 },
      { text: 'All', value: total?.totalItems }
    ]
  };

  const selectRow = {
    selected: itemToDelete,
  };

  const handleRowSelect = (rowId) => {
    if (itemToDelete.includes(rowId)) {
      setItemToDelete(itemToDelete.filter((id) => id !== rowId));
    } else {
      setItemToDelete([...itemToDelete, rowId]);
    }
  };

  const handleSort = (field) => {
    const sortedData = [...apiData].sort((a, b) => {
      if (a[field] < b[field]) return -1;
      if (a[field] > b[field]) return 1;
      return 0;
    });
    setApiData(sortedData);
  };

  const handleSelectAll = () => {
    if (itemToDelete.length === apiData.length) {
      setItemToDelete([]);
    } else {
      setItemToDelete(apiData.map((row) => row.id));
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setPage(1);
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, formData?.title, withOutRefresh, draft]);

  useEffect(() => {
    setDeleteActionType(draft === 1 ? 3 : 2);
    setItemToDelete([]);
  }, [draft]);

  return (
    <>
      <div className="">
        {showOverlay && <Response_Processing />}
        {modelClose && <AdminDeleteModal
          messageClassName={deleteActionType === 1 ? "warningColor" : ""}
          headingText={deleteActionType == 3 ? "Confirm Undo" : deleteActionType == 1 ? "Confirm Permanent Delete" : "Confirm Delete"}
          message={deleteActionType == 3 ? "Are you sure you want to restore the selected item ?" : deleteActionType == 1 ? "Warning: This action will permanently delete the selected items from the server. Once deleted, the data cannot be recovered. Are you sure you want to proceed?" : "Are you sure you want to delete the selected item ?"}
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleDeletedata}
          buttonText={"custom"}
          actionText={deleteActionType == 1 ? "Delete Permanent" : deleteActionType == 3 ? "Undo" : "Delete"}
        />}
        <AdminNavbar heading="Video Playlist" totalDataLength={total?.totalItems} deleteCount={itemToDelete?.length} deleteMethod={openModal} {...(userRole == 1 && { navigation: "/add-playlist", navText: "Video Playlist" })} />
        <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width">
          <div className='theme-bg-color p-3 rounded-3 mb-5'>
            <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
              <input type='search' id="video-playlist-search-input" placeholder='Search' name="title" className='rounded-3 col-3 theme-border-color border-solid-width border-solid table-search theme-bg-color-secondary' onChange={handleInput} />
              <div className='d-flex align-items-center justify-content-end'>
                {(userRole == 1 && draft !== 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete" className={"warningColorBg me-2"} saveMethod={() => { setModelClose(true); setDeleteActionType(2); }} /> : ""}
                {(userRole == 1 && draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Undo" className={"mx-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(3); }} /> : ""}
                {(userRole == 1 && draft == 1 && itemToDelete?.length > 0) ? <AdminCustomButton saveText="Delete Permanent" className={"me-3"} saveMethod={() => { setModelClose(true); setDeleteActionType(1); }} /> : ""}
                {userRole == 1 && (
                  <button id="video-playlist-recycleButton" className={`custom-tool-tip-parent reloadButton p-2 me-2 border border-2 rounded-circle theme-border-color ${draft ? "button-bg-color theme-button-text-color" : " bg-transparent theme-text-color"}`} onClick={reCycleBin}>
                    <BiRecycle style={{ width: "18px", height: "15px" }} />
                    <AdminTooltip text="Recycle Bin" top={"-41px"} className="d-none custom-tool-tip" />
                  </button>
                )}
                <button id="video-playlist-reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2 primary border border-2 rounded-circle theme-border-color`} onClick={reloadAction}>
                  <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                  <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />
                </button>
                <div className="dropdown d-block ms-2">
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="video-playlist-exportButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className="fw-bolder text-white">Export</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="video-playlist-exportButton">
                    <li id="video-playlist-exportCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV")}>CSV</li>
                    <li id="video-playlist-exportPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF")}>PDF</li>
                    <li id="video-playlist-exportXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX")}>XLSX</li>
                  </ul>
                </div>
                <div className="dropdown d-block ms-2">
                  <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="video-playlist-exportAllButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className="fw-bolder text-white">Export all</span>
                    <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                  </button>
                  <ul className="dropdown-menu theme-bg-color" aria-labelledby="video-playlist-exportAllButton">
                    <li id="video-playlist-exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchAllData("CSV", "ALL")}>CSV</li>
                    <li id="video-playlist-exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchAllData("PDF", "ALL")}>PDF</li>
                    <li id="video-playlist-exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchAllData("XLSX", "ALL")}>XLSX</li>
                  </ul>
                </div>
              </div>
            </div>

            <AdminTable
              data={apiData}
              loading={loading}
              options={options}
              handlePageChange={handlePageChange}
              page={page}
              pagination={total}
              handleSizePerPageChange={handleSizePerPageChange}
              columns={columns}
              limit={limit}
              selectRow={selectRow}
              multiSelect={userRole == 1}
              onRowSelect={handleRowSelect}
              onSort={handleSort}
              onSelectAll={handleSelectAll}
              viewType={formData?.view_type}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AllVideo_Playlist;
